import React from 'react';
import styles from './ZombiePurgeContent.module.scss';

const ZombiePurgeContent = ( props )=> {
	return (
		<div className={` w-full h-auto flex z-20 mb-12 relative items-start justify-between  ${styles['zombie-purge-content']} ${props.className}`}>
			<div className={`bg-no-repeat bg-auto bg-right w-[200px] h-[200px] mt-[5%] ${styles['zombie-purge-content-box-strip']}`} />
			<div className={`relative bg-[#0b0f1b]   backdrop-blur-2xl grow rounded-2xl flex flex-col items-center h-auto ${styles['zombie-purge-content-box']}`}>
				<span className={`absolute w-9 h-9 rounded-full ${styles['zombie-purge-content-box-circle']}`}/>
				<span className={`absolute w-9 h-9 rounded-full ${styles['zombie-purge-content-box-circle']}`}/>

				{/* this is where box content is put it wether its zombie list or connect wallet or so on */}
				<div className={`max-[1000px]:pr-8 max-[1000px]:pl-8 pr-12 pl-12 pt-7 pb-14 h-auto w-full ${styles['zombie-purge-content-box-inner']}`}>{props.children}</div>

				<span className={`absolute  w-9 h-9 rounded-full ${styles['zombie-purge-content-box-circle']}`}/>
				<span className={`absolute  w-9 h-9 rounded-full ${styles['zombie-purge-content-box-circle']}`}/>

			</div>
			<div className={`bg-no-repeat bg-auto bg-right w-[200px] h-[200px] mt-[5%] ${styles['zombie-purge-content-box-strip']}`}
				style={{ rotate: '180deg' }}/>
		</div>
	);
};

export default ZombiePurgeContent;
